import React from 'react';
import translate from './translate';
import beeBadge from './bee_badge.png';

const ElementaryBeeBadge_fi = (): JSX.Element => {
  return (
    <div>
      <p><mark>Harmonia-Hiiren häntä viuhuu matkalaukussa. Se toivoo löytävänsä sieltä jotakin hienoa. Yhtäkkiä sen käpäliin osuu jotakin kovaa. Harmonia nostaa ja näyttää merkkiä Lotalle ja Oodille. Kaverukset tutkivat sitä yhdessä, ja miettivät, mikä merkin tarina on. Ullakon seinien raoista kuuluu naapuruston iloisia ääniä. Naapurit ovat yhdessä päättäneet maalata läheisen leikkipuiston välinevaraston.</mark></p>
      <p><strong>Lasten ja nuorten talkoot</strong></p>
      <img className="large" src={beeBadge} alt={translate('bee_badge')}/>
      <p>Vuoden 1943 kotirintaman talkoomerkki (Turun museokeskuksen lisenssi cc by nd-4.0)</p>
      <p>Nuorten Talkoot oli vapaaehtoista toimintaa lasten ja nuorten keskuudessa. Mm. <a target="_blank" rel="noreferrer" href="https://fi.wikipedia.org/wiki/Lotta_Sv%C3%A4rd">Lotta Svärd</a> -järjestön pikkulottina toimi 40 000 tyttöä 8- ja 16-ikävuoden väliltä. Nuorten Talkoiden toiminta jakaantui talkootyöhön, keräilyyn ja säästötalkoisiin.</p>
      <p><strong>Pohdinta-/Tehtävävinkkejä: </strong></p>
      <ul>
        <li>Selvitä, mitä töitä kuului Nuorten Talkoiden toimintaan? a.) talkootyö, b.) keräily, c.) säästötalkoot</li>
      </ul>
      <ul>
        <li>Mitä tarkoittaa talkoot? Oletko sinä osallistunut joskus talkoisiin? Minkälaisia erilaisia talkootilanteita on olemassa/voisi olla?</li>
      </ul>
      <ul>
        <li>Keksikää joku talkoohenkinen työ tai toiminta, joka hyödyntäisi yhteisöä (Lastensairaalaan tms. pikkutäkkien ompelu/myssyjen neulominen vastasyntyneille, vanhainkoteihin ulkoilutäkkien tekeminen, helpon kasvomaskin ompelu, joulukorttien tekeminen ja lähettäminen vanhainkoteihin, roskien kerääminen koulun/taloyhtiön/vanhainkodin ympäristöstä)</li>
      </ul>
      <ul>
        <li>Miten talkootöissä voi huomioida kestävän kehityksen ja kierrätyksen? (Voitte käydä koulun pelit/välineet läpi, ja korjata tai huoltaa ne.)</li>
      </ul>
      <p><em>“Nuorten Talkoiden toimintatapa oli laadittu kilpailulliseksi niin, että joka vuosi kerättiin pisteitä eri tehtävistä, ja syksyisin ahkeruudesta sai kullatun, hopeoidun tai rautaisen talkoomerkin. ”Romumuurahaismerkin” sai keräämällä 20 ehjää pulloa, ”talkoomuurahaismerkin” jos keräsi tietyn määrän jätepuita tai </em><a target="_blank" rel="noreferrer" href="https://fi.wikipedia.org/wiki/K%C3%A4py"><em>käpyjä</em></a><em> autettavalle perheelle.” </em>(<a target="_blank" rel="noreferrer" href="https://fi.wikipedia.org/wiki/Nuorten_Talkoot">https://fi.wikipedia.org/wiki/Nuorten_Talkoot</a>.)</p>
      <ul>
        <li>Suunnittele itse tai pienessä ryhmässä oma talkoomerkki. </li>
      </ul>
      <ul>
        <li>Mitä suunnittelussa tulisi ottaa huomioon? Esimerkiksi miten ja mihin se voidaan kiinnittää? Mistä materiaalista (huom! monimateriaalisuus ja kierrätysmateriaalien hyödyntäminen), millä välineillä ja millaisin työtavoin sitä voidaan työstää ja toteuttaa? </li>
      </ul>
      <ul>
        <li>Miten voit esimerkiksi tehdä näitä merkkejä?
          <ul>
            <li>piirtämällä tai maalaamalla esimerkiksi käyttämällä erilaisia piirustus- ja suunnitteluohjelmia</li>
            <li>ompelemalla (huovasta, kankaista tai nahasta)</li>
            <li>työstämällä merkin puusta tai pakottamalla metallista tai vaikka kokeilla 3D-tulostinta merkin luomiseen, ja harjoitella samalla esimerkiksi Tinkercad-ohjelman käyttöä merkin suunnittelussa.</li>
            <li>Voisiko tämä merkki olla virtuaalinen, ja voisiko niitä kerätä ja pitää näkyvillä jollakin alustalla tai ohjelmassa?</li>
          </ul>
        </li>
      </ul>
      <p><strong>KOODITEHTÄVÄ 2.: Mikä on merkissä näkyvän vuosiluvun kolmannen numeron ensimmäinen kirjain?</strong></p>
    </div>
  );
};

export default ElementaryBeeBadge_fi;
